import { Component, Input, Output, OnInit, EventEmitter, ViewChildren, QueryList, ViewEncapsulation } from '@angular/core';
import { Utilities } from '../../services/Utilities';
import { GoogleData } from '../../services/GoogleData/GoogleData';
import { Book } from '../../services/GoogleData/Book';
import { SearchConfigService, SearchConfigInstance } from '../../services/SearchConfigService'
import { BookComponent } from '../book/book';
import { Analytics } from '../../services/Analytics'

import { BehaviorSubject } from 'rxjs'

@Component({
    selector: 'search',
    templateUrl: './search.html',
    styleUrls: ['./search.css', './search.mobile.css'],
    encapsulation: ViewEncapsulation.None
})
export class SearchComponent implements OnInit {
    @Input() searchMode;
    @Input() allowBookSelection:boolean = false;
    @Output() onBookSelect:EventEmitter<string> = new EventEmitter<string>();

    @ViewChildren(BookComponent) childBooks:QueryList<BookComponent>;

    preventBubbling:(any) => void;

    selectedBook:string;
    searchConfig:SearchConfigInstance;

    search = {
        query: new BehaviorSubject<string>(""), 
        results: null, 
        isLoading: false, 
        isLookup: false,
        resultsAreLookup: false,
        cache: {},
        lookupIsValid: () => {
            if (this.search.isLookup) {
                return this.googleData.ISBNOrGoogleIdIsValid(this.search.query.getValue());
            }
        }
    };

    async doSearch() {
        Analytics.search();
        document.getElementById('search_input').blur();
        if (this.search.query.getValue().length > 0) {
            this.search.isLoading = true;
            var booksList = await this.googleData.getGoogleBooksList(this.search.query.getValue(), 0, 40);
            
            this.search.resultsAreLookup = false;
            this.search.isLoading = false;
            this.search.cache = {};
            var results = [];
            (booksList.books || []).forEach((book:Book) => {
                this.search.cache[book.googleId] = book;
                results.push({googleId:book.googleId});
            });
            this.search.results = results;
        }
    };

    selectBook(googleId:string) {
        if (this.allowBookSelection) {
            this.selectedBook = googleId;
            if (this.onBookSelect) {
                this.onBookSelect.emit(googleId);
            }
        }
    }

   async doLookup() {
        Analytics.lookup();
        
        document.getElementById('search_input').blur();
        if (this.search.query.getValue().length > 0) {
            this.search.isLoading = true;
            
            if (this.googleData.isValidISBN(this.search.query.getValue())) {
                try {
                    var googleId = await this.googleData.getGoogleIdFromISBN(this.search.query.getValue());
                    this.search.resultsAreLookup = true;
                    this.search.isLoading = false;
                    this.search.cache = {};
                    if (googleId) {
                        this.search.results = [{googleId: googleId}];
                    } else {
                        this.search.results = [];
                    }
                } catch (err) {
                    console.warn(err);
                    this.search.resultsAreLookup = false;
                    this.search.isLoading = false;
                    this.search.results = [];
                }
            } else {
                try {
                    var result = await this.googleData.getBook(this.search.query.getValue());
                    if (result) {
                        this.search.results = [{googleId: this.search.query.getValue()}];
                    } else {
                        this.search.results = [];
                    }
                    this.search.resultsAreLookup = true;
                    this.search.isLoading = false;
                } catch (err) {
                    this.search.resultsAreLookup = true;
                    this.search.isLoading = false;
                    this.search.results = [];
                }
            }
        }
    }

    lookupOrSearch() {
        this.search.results = null;
        if (this.search.isLookup) {
            if (this.search.lookupIsValid()) {
                this.doLookup();
            }
        } else {
            this.doSearch();
        }
    };

    closeDropdowns() {
        this.childBooks.forEach((bookComponent) => {
            bookComponent.closeDropdown();
        })
    }

    constructor(private googleData:GoogleData, searchConfigService:SearchConfigService) {
        searchConfigService.config.subscribe((searchConfig) => {
            this.searchConfig = searchConfig;
        });

        this.preventBubbling = Utilities.preventBubbling;
    }
    
    ngOnInit() {
        document.getElementById('search_input').focus();
    }
}


// WEBPACK FOOTER //
// ./web/static/components/search/search.ts